import {
  DotsMenu,
  MenuLineSeparator,
  MenuOption,
} from "@smartsuite/react-ui/lib";
import { Colors, GrayColors, SolutionColorVariables } from "@smartsuite/types";
import { useState } from "react";
import { DeleteConfirmationDialog } from "../DeleteConfirmationDialog/DeleteConfirmationDialog";
import { showElementWithoutImplementation } from "../utils";

export interface PageDesignerDotsMenuProps {
  onDelete: () => Promise<void>;
  onRename: () => void;
  onDuplicate: () => void;
}

export const PageDesignerDotsMenu: React.FC<PageDesignerDotsMenuProps> = ({
  onDelete,
  onRename,
  onDuplicate,
}) => {
  const [isOpened, setIsOpened] = useState(false);
  const [
    isDeleteConfirmationDialogOpened,
    setIsDeleteConfirmationDialogOpened,
  ] = useState(false);

  return (
    <>
      <DotsMenu
        opened={isOpened}
        my="center top+10"
        at="center bottom"
        minWidth={240}
        smallListPaddings={true}
        backgroundColors={{
          hover: SolutionColorVariables.sc2,
          active: SolutionColorVariables.sc2,
        }}
        colors={{
          default: GrayColors["G-5"],
          hover: SolutionColorVariables.sc1,
          active: SolutionColorVariables.sc1,
        }}
        onToggle={(opened: boolean): void => {
          setIsOpened(opened);
        }}
      >
        <MenuOption
          iconName="edit-smaller"
          onClick={() => {
            onRename();
            setIsOpened(!isOpened);
          }}
        >
          Rename
        </MenuOption>
        {showElementWithoutImplementation && (
          <MenuOption iconName="edit-smaller">Add Description</MenuOption>
        )}

        <MenuOption
          iconName="layers"
          onClick={() => {
            setIsOpened(!isOpened);
            onDuplicate();
          }}
        >
          Duplicate Design
        </MenuOption>
        <MenuLineSeparator smallOffset />
        <MenuOption
          iconName="trash"
          iconColor={Colors.bRed}
          onClick={() => {
            setIsOpened(!isOpened);
            setIsDeleteConfirmationDialogOpened(
              !isDeleteConfirmationDialogOpened,
            );
          }}
        >
          Delete Design
        </MenuOption>
      </DotsMenu>
      <DeleteConfirmationDialog
        isOpened={isDeleteConfirmationDialogOpened}
        onConfirm={onDelete}
        onCancel={() => {
          setIsDeleteConfirmationDialogOpened(
            !isDeleteConfirmationDialogOpened,
          );
        }}
      />
    </>
  );
};
